import React, { useEffect, useState } from "react";
import { Form, message, Table, Button, Modal, Drawer, Row, Col, Spin } from "antd";
import ReactJson from "@microlink/react-json-view";
import { FormGenerator } from '../../common/FormGenerator';
import { getWorkFlowAllData, getWorkflowMetaDataSearchResult } from '../../../services/admin/adminService';
import commmonConfig from '../../common/config';
import '../assets/styles/common.css';
import Grid from "../components/CommonFields/Grid";
import dayjs from "dayjs";
const dateFormat = 'YYYY-MM-DD';


const SearchMetaDataResult = ({ wfId }) => {
    const [form] = Form.useForm();
    const [fields, setFields] = useState(commmonConfig.defaultSearchFields || []);
    const [searchResults, setsearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fieldsLoading, setFieldsLoading] = useState(false);
    const [formKey, setFormKey] = useState(0); // to force re-render Form

    const [showDrawer, setShowDrawer] = useState(false);
    const [jsonVisible, setJsonVisible] = useState(false);
    const [selectedJson, setSelectedJson] = useState(null);

    // Table Columns
    const columns = [
        {
            title: "Meta Data ID",
            dataIndex: "meta_data_id",
            key: "meta_data_id",
        },
        {
            title: "Key 1",
            dataIndex: "key_1",
            key: "key_1",
        },
        {
            title: "key 2",
            dataIndex: "key_2",
            key: "key_2",
        },
        {
            title: "key 3",
            dataIndex: "key_3",
            key: "key_3",
        },
        {
            title: "Data JSON",
            dataIndex: "meta_data_value",
            key: "meta_data_value",
            render: ["viewjson"],
        },
        {
            title: "Created Date",
            dataIndex: "created_at",
            key: "created_at",
        }
    ];

    useEffect(() => {
        getMetaDataFieldList();
    }, [wfId]);

    const getMetaDataFieldList = async () => {
        setFieldsLoading(true);
        try {
            const response = await getWorkFlowAllData(wfId);
            const jsonData = response?.data;
            if (jsonData.success) {
                const metaData = jsonData?.data?.metaData;
                if (metaData?.length > 0) {
                    const parsedMetaData = metaData.map(item => {
                        const config = JSON.parse(item.metaDataConfig);
                        const indexes = config.Indexes || {};
                        const validFields = config.Fields?.filter(field =>
                            Object.values(indexes).includes(field.Name)
                        );
                        return validFields || [];
                    }).flat();
                    setFields([...commmonConfig.defaultSearchFields || [], ...parsedMetaData]);
                } else {
                    setFields(commmonConfig.defaultSearchFields || []);
                }
            }
        } catch (error) {
            console.error('Error fetching metadata fields:', error);
        } finally {
            setFieldsLoading(false);
        }
    };

    const handleSearchBtnClick = async () => {
        setFormKey(prev => prev + 1);
        form.resetFields();
        setShowDrawer(true);
        await getMetaDataFieldList();
    };

    function isValidDate(value) {
        if (value) {
            return dayjs(value).isValid();
        }
        return value;
    }

    const handleSearch = async () => {
        setShowDrawer(false);
        setLoading(true);
        try {
            const values = await form.validateFields();

            //Get field name 'Index' node value(column used in metadata search 'key_1',..) set in JSON to search
            const dataKeyMap = {};
            fields.forEach(field => {
                dataKeyMap[field.Name] = field.Index || "";
            });
            // console.log("values:", values);
            // console.log("dataKeyMap:", dataKeyMap);

            const formattedData = [];
            Object.keys(values).forEach(fieldName => {
                const dataKey = dataKeyMap[fieldName];
                if (dataKey) {
                    const searchVal = values[fieldName] || "";

                    //Here we checked the value is date format if so we add mysql conversion 'DATE(value)'
                    const isDate = searchVal ? isValidDate(searchVal) : false;
                    formattedData.push({
                        Name: fieldName,
                        Key: isDate ? `Date(${dataKey})` : dataKey,
                        Value: isDate
                            ? dayjs(searchVal).format(dateFormat)
                            : searchVal || "",
                        Type: isDate ? "Date" : "String"
                    });
                }
            });

            // console.log("va:", values);
            //console.log("oop:", formattedData);

            if (values) {
                const res = await getWorkflowMetaDataSearchResult(wfId, formattedData);
                if (res.data.success) {
                    const resutObj = res.data.data.result;
                    if (resutObj?.length > 0) {
                        setsearchResults(resutObj);
                    }
                    else {
                        setsearchResults([]);
                    }
                }
                else {
                    setsearchResults([]);
                }
            }
        } catch (error) {
            message.error("Validation Failed:", error);
            console.error("Validation Failed:", error);
        }
        finally {
            setLoading(false);
        }
    };

    const closeDrawer = () => {
        setShowDrawer(false);
    };


    const handleViewJson = (jsonData) => {
        try {
            const parsed = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;
            setSelectedJson(parsed);
            setJsonVisible(true);
        } catch (error) {
            console.error("Invalid JSON:", error);
        }
    };


    return (

        <>
            <Row>
                <Col span={24} style={{ textAlign: 'right', paddingBottom: '10px' }}>
                    <Button type="primary" onClick={handleSearchBtnClick}>Filter</Button>
                </Col>
            </Row>


            {showDrawer && (
                <Drawer
                    title="Search Metadata"
                    placement="right"
                    className="custom-drawers cus-drawer-sm"
                    onClose={() => setShowDrawer(false)}
                    open={showDrawer}
                    width={600}
                    footer={
                        <div style={{ textAlign: 'right' }}>
                            <Button onClick={closeDrawer} style={{ marginRight: 8 }}>
                                Cancel
                            </Button>
                            <Button type="primary" onClick={handleSearch}>Search</Button>
                        </div>
                    }
                >
                    <Spin spinning={fieldsLoading} tip="Loading form...">
                        <Form form={form} layout="vertical">
                            {fields.map((field) => (
                                <Form.Item key={field.Name} label={field.Name} name={field.Name}>
                                    {FormGenerator({ field })}
                                </Form.Item>
                            ))}
                        </Form>
                    </Spin>

                </Drawer>
            )}
            <Spin spinning={loading} tip="Loading...">

                {searchResults && (
                    <>
                        <Row>
                            <Col span={24}>
                                {/* <Table dataSource={searchResults} columns={columns} rowKey="meta_data_instance_id" /> */}

                                <Grid
                                    columnData={{ columns: columns }}
                                    tableData={searchResults}
                                    rowKey="meta_data_instance_id"
                                    handleViewJson={(text) => handleViewJson(text)}
                                    searchButton={true}
                                    downloadCSV={true}
                                    showEdit={false}
                                    showDelete={false}
                                    showView={false}
                                    csvFileName="StepData"
                                    paginationConfig={{ pageSizeOptions: ['10', '20', '50', '100'] }}
                                    className="custom-grid"
                                    createButton={false}
                                    loading={loading}
                                />


                            </Col>
                        </Row>
                        <Modal
                            title="JSON Data"
                            open={jsonVisible}
                            onCancel={() => setJsonVisible(false)}
                            footer={null}
                            width={600}
                            className='cus-antd-white'
                        >
                            {selectedJson && <ReactJson src={selectedJson} theme="chalk" />}
                        </Modal>
                    </>
                )}
            </Spin>

        </>
    );
};

export default SearchMetaDataResult;
